const styles = {
  container: 'flex flex-row items-center gap-x-3 text-black',
  paragraph: 'text-xl mt-1',
};

export default styles;
